import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
//import { Router, NavigationExtras } from '@angular/router';

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  contactForm;
  constructor(
    public builder:FormBuilder,
    public bp:BasicProvider, 
  ) {

    this.setContactForm();
  }

  ngOnInit() {
  }

  public setContactForm(){
    this.bp.validation_error = '';
    this.contactForm = this.builder.group({
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z\-]{2}[a-zA-Z\-]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')])],
      message:['', Validators.compose([Validators.required])],
    })
  }

  public contactFormSubmit () {

    var validation_message = {
      'name': {
        'required': 'Full name is required field.',
        'invalidChar': 'Please provide valid full name'
      },
      'email': {
        'required': 'Email is required field.',
        'pattern': 'Please enter valid email.'
      },
      'message': {
        'required': 'Please enter your message.'
      }
    };

    //console.log(this.contactForm);

    let p = window.location.pathname.replace(this.bp.SUBFOLDER_NAME, "");
    if(this.bp.validation(this.contactForm, validation_message)) {
      this.bp.validation_error = '';
      let submitData = this.contactForm.value;
      this.bp.hitApi('settings/web_contact_us', 'POST', submitData,true,true)
      .subscribe(
      success => {
        if (success.type) {
          this.setContactForm();
          this.bp.show_toast('Success',success.message);
        } else {
          this.bp.validation_error = success.message; 
        }
      }, error => { })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/contact-us/contact-us.component.ts